import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "logoPrestige"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "app-bar-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_ctx.time)
    ? (_openBlock(), _createBlock(_component_v_app, {
        key: 0,
        id: "app",
        style: _normalizeStyle({ '--vh': _ctx.cssVariables.vh })
      }, {
        default: _withCtx(() => [
          (_ctx.showAppBar)
            ? (_openBlock(), _createBlock(_component_v_app_bar, {
                key: 0,
                density: "compact",
                flat: "",
                height: 60
              }, {
                default: _withCtx(() => [
                  (!_ctx.isCompactWindow)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("img", {
                          src: _ctx.logo,
                          alt: "Patiently Logo",
                          width: "120",
                          height: "40"
                        }, null, 8, _hoisted_2)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, _toDisplayString(this.$dayjs(this.time).format('hh:mm A')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, {
                class: "fullHeight container",
                fluid: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]))
    : _createCommentVNode("", true)
}